import React, {useContext, useEffect} from 'react';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  postAddressData,
  postContactsData,
  resetToast,
} from '../../../redux/reducers/clientMangement/Organizaation';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {STATE} from '../../../constants/Lookup';
import {getOptions} from '../../../util/GetDropDownOptions';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const CompanyForm = ({setOpen = () => {}, id, type, selectedRows}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const {successMsg, errorMsg, dropDownData, editAddressData, editContactData} = useSelector(
    ({organization}) => organization,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  const validationSchema = Yup.object().shape({
    addressType: Yup.mixed()
      .test('addressType', 'Address Type is required', (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      })
      .required('Address Type is required'),
    address1: Yup.string()
      .max(50, 'Address Line 1 cannot exceed 50 characters')
      .required('Address Line 1 is required'),
    address2: Yup.string()
      .max(50, 'Address Line 2 cannot exceed 50 characters'),
    // .required("Address Line 2 is required"),
    city: Yup.string().max(20, 'City cannot exceed 20 characters').required('City is required'),
    country: Yup.string()
      .required('Country is required'),
    state: Yup.mixed().test('state', 'State is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    zip: Yup.string()
      .min(5, 'Zip Code cannot be less than 5 characters')
      .max(9, 'Zip Code cannot exceed 9 characters')
      .required('Zip Code is required'),
    // locationCode: Yup.string().required("Location Code is required"),
    addressFlag: Yup.mixed().test('addressFlag', 'Address Flag is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
  });
  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };
  const initialVal = {
    address1: editAddressData?.address1 || editContactData?.address1 || '',
    address2: editAddressData?.address2 || editContactData?.address2 || '',
    addressType: getOption(dropDownData?.CLIENT_ADDRESS_TYPE, 'value', editAddressData?.addressType || editContactData?.addressType) || {},
    city: editAddressData?.city || editContactData?.city || '',
    country: editAddressData?.country || editContactData?.country || 'USA-United States of America',
    locationCode: editAddressData?.locationCode || editContactData?.locationCode || '',
    optInFlag: editAddressData?.optInFlag || editContactData?.optInFlag || 'Yes',
    orgAddressId: 0,
    orgId: id,
    orgType: type,
    state: getOption(dropDownData?.STATE, 'value', editAddressData?.state || editContactData?.state) || {},
    zip: editAddressData?.zip || editContactData?.zip || '',
    addressFlag: getOption(dropDownData?.ADDRESS_FLAG, 'value', editAddressData?.addressFlag || editContactData?.addressFlag) || {},
  };

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    if (values) {
      const data = {
        optInFlag: values?.optInFlag || 'Yes',
        address1: values?.address1 || '',
        address2: values?.address2 || '',
        addressType: values?.addressType?.value || '',
        city: values?.city || '',
        country: values?.country || '',
        locationCode: values?.locationCode || '',
        orgAddressId: editAddressData?.orgAddressId || 0,
        orgId: id,
        orgType: type || '',
        seqNo: editAddressData?.seqNo ?
          editAddressData?.seqNo :
          Array.isArray(selectedRows) ?
            selectedRows?.length + 1 :
            1,
        state: values?.state?.value || '',
        zip: values?.zip || '',
        addressFlag: values?.addressFlag?.value || '',
      };
      dispatch(postAddressData(data));
    } else if (values) {
      const data = {
        addressOptIn: values?.optInFlag || 'Yes',
        address1: values?.address1 || '',
        address2: values?.address2 || '',
        addressType: values?.addressType?.value || '',
        city: values?.city || '',
        country: values?.country || '',
        locationCode: values?.locationCode || '',
        orgAddressId: editContactData?.orgAddressId || 0,
        orgId: id,
        orgType: type || '',
        state: values?.state?.value || '',
        zip: values?.zip || '',
        addressFlag: values?.addressFlag?.value || '',
      };
      dispatch(postContactsData(data));
    }
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleChange,
            setFieldValue,
            resetForm,
          } = props;
          return (
            <div className={classes.dialoguecardStyles}>
              <Form autoComplete="off" noValidate>
                <div className="form-row global-field-textfields  new-standard-textfields">
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      id="addressType"
                      className={'errorcontent'}
                      options={dropDownData?.CLIENT_ADDRESS_TYPE || []}
                      size="small"
                      disabled={editContactData}
                      value={values.addressType}
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Address Type"
                          name="addressType"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          touched={touched.addressType}
                          error={touched.addressType && errors.addressType}
                          required={!editContactData}
                          placeholder="Select Address Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        setFieldValue('addressType', data);
                      }}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.addressType && errors?.addressType && errors.addressType}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Address Line 1"
                      margin="dense"
                      name="address1"
                      variant="outlined"
                      disabled={editContactData}
                      value={values.address1}
                      onChange={handleChange}
                      required={!editContactData}
                      label="Address Line 1"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                      touched={touched.address2}
                      error={touched.address1 && errors.address1}
                    />
                    <FormHelperText variant="outlined">
                      {touched.address1 && errors?.address1 && errors.address1}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Address Line 2"
                      margin="dense"
                      name="address2"
                      variant="outlined"
                      disabled={editContactData}
                      value={values.address2}
                      onChange={handleChange}
                      label="Address Line 2"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                      touched={touched.address2}
                      error={touched.address2 && errors.address2}
                    />
                    <FormHelperText variant="outlined">
                      {touched.address2 && errors?.address2 && errors.address2}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter City"
                      margin="dense"
                      name="city"
                      disabled={editContactData}
                      variant="outlined"
                      label="City"
                      required={!editContactData}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      value={values.city}
                      onChange={handleChange}
                      fullWidth
                      touched={touched.city}
                      error={touched.city && errors.city}
                    />
                    <FormHelperText variant="outlined">
                      {touched.city && errors?.city && errors.city}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      id="state"
                      options={getOptions(STATE, dropDownData)}
                      size="small"
                      className={'errorcontent'}
                      value={values.state}
                      autoHighlight
                      disabled={editContactData}
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="State"
                          name="state"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          required={!editContactData}
                          placeholder="Select State"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                          touched={touched.state}
                          error={touched.state && errors.state}
                        />
                      )}
                      onChange={(_, data) => {
                        setFieldValue('state', data);
                      }}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.state && errors?.state && errors.state}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Zip Code"
                      margin="dense"
                      name="zip"
                      disabled={editContactData}
                      variant="outlined"
                      label="Zip Code"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      required={!editContactData}
                      value={values.zip}
                      onChange={handleChange}
                      fullWidth
                      touched={touched.zip}
                      error={touched.zip && errors.zip}
                    />
                    <FormHelperText variant="outlined">
                      {touched.zip && errors?.zip && errors.zip}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Country"
                      margin="dense"
                      name="country"
                      variant="outlined"
                      label="Country"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      disabled={editContactData}
                      required={!editContactData}
                      value={values.country}
                      onChange={handleChange}
                      fullWidth
                      error={errors && errors.country}
                    />
                    <FormHelperText variant="outlined">
                      {errors?.country ? errors.country : ''}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Location Code"
                      margin="dense"
                      name="locationCode"
                      variant="outlined"
                      label="Location Code"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // required
                      disabled={editContactData}
                      value={values.locationCode}
                      onChange={handleChange}
                      fullWidth
                    />
                  </div>
                  <div
                    className={`col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group ${classes.selectField}`}
                  >
                    <FormControl
                      // margin="dense"
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel id="demo-simple-select-label" >Opt In</InputLabel>
                      <Select
                        fullWidth
                        name="optInFlag"
                        className={`${classes.labelName}`}
                        disabled={editContactData}
                        label="Opt In"
                        id="demo-simple-select"
                        labelId="demo-simple-select-label"
                        value={values.optInFlag}
                        required={!editContactData}
                        onChange={(e) => {
                          setFieldValue('optInFlag', e.target.value);
                        }}
                      >
                        {['Yes', 'No'].map((option) => {
                          return (
                            <MenuItem value={option} key={option}>
                              {option}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      id="addressFlag"
                      className={'errorcontent'}
                      options={dropDownData?.ADDRESS_FLAG || []}
                      size="small"
                      value={values.addressFlag}
                      disabled={editContactData}
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Address Flag"
                          name="addressFlag"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          required={!editContactData}
                          placeholder="Select Address Flag"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                          touched={touched.addressFlag}
                          error={touched.addressFlag && errors.addressFlag}
                        />
                      )}
                      onChange={(_, data) => {
                        setFieldValue('addressFlag', data);
                      }}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.addressFlag && errors?.addressFlag && errors.addressFlag}
                    </FormHelperText>
                  </div>
                </div>
                {!editContactData && (
                  <div className="d-flex justify-content-center align-items-center new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        resetForm();
                      }}
                    >
                    Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                      disabled={enabledSubmission}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default CompanyForm;
